<ul class="file-list">
  <ng-container *ngFor="let file of files; let i = index">
    <li class="file-list-item">
      <div class="file-list-item-content">
        <icon set="lucide" size="18" name="paperclip" />

        <div class="w-100 d-flex flex-column">
          <button
            *ngIf="clickableNames; else plainLabel"
            type="button"
            class="file-list-item-content-label file-list-item-content-label--clickable"
            (click)="onFileNameClick(i)"
          >
            {{ file.filename }}
          </button>
          <ng-template #plainLabel>
            <div class="file-list-item-content-label">
              {{ file.filename }}
            </div>
          </ng-template>
          <div
            *ngIf="file.content || file.size != null"
            class="file-list-item-content-value"
          >
            {{ file.content?.size || file.size || 0 | fileSize }}
          </div>
        </div>

        <ng-container *ngIf="removable; else uploadedStatusIcon">
          <icon
            class="file-list-item-content-icon file-list-item-content-icon--pointer"
            set="lucide"
            size="18"
            name="x"
            (click)="onRemove(i)"
          />
        </ng-container>
        <ng-template #uploadedStatusIcon>
          <icon
            class="file-list-item-content-icon"
            set="uil"
            name="check-circle"
          />
        </ng-template>
      </div>
    </li>
  </ng-container>
</ul>
